import {
  LayoutGrid,
  MessageSquare,
  User,
  Shield,
  BookCopy,
  Dumbbell,
  Pizza,
  Activity as ActivityIcon,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { User as AppUser } from "../types";

type NavItem = {
  href: string;
  icon: LucideIcon;
  label: string;
  roles: AppUser["role"][];
};

export const navItems: NavItem[] = [
  {
    href: "/feed",
    icon: LayoutGrid,
    label: "Feed",
    roles: ["user", "trainer", "glavni_trener", "admin"],
  },
  {
    href: "/exercises",
    icon: Dumbbell,
    label: "Vježbe",
    roles: ["user", "trainer", "glavni_trener", "admin"],
  },
  {
    href: "/chat",
    icon: MessageSquare,
    label: "Chat",
    roles: ["user", "trainer", "glavni_trener", "admin"],
  },
  {
    href: "/profile",
    icon: User,
    label: "Profil",
    roles: ["user", "trainer", "glavni_trener", "admin"],
  },
  {
    href: "/users",
    icon: Shield,
    label: "Korisnici",
    roles: ["admin", "glavni_trener", "trainer"],
  },
  {
    href: "/admin/activity",
    icon: ActivityIcon,
    label: "Aktivnosti",
    roles: ["admin", "glavni_trener", "trainer"],
  },
  {
    href: "/admin/assign-plans",
    icon: BookCopy,
    label: "Planovi",
    roles: ["admin", "glavni_trener", "trainer"],
  },
  {
    href: "/admin/foods",
    icon: Pizza,
    label: "Namirnice",
    roles: ["admin", "glavni_trener"],
  },
];
